import * as endpoints from './endpoints';

const InteractionService = { ...endpoints };

export default InteractionService;
export type {
  CptInteraction,
  CptMonthBucket,
  InteractionTimeEntry,
  CreateTimeEntryParams,
} from './endpoints';
